import { render } from "./App.vue?vue&type=template&id=536cdcd3"
const script = {}

import "./App.vue?vue&type=style&index=0&id=536cdcd3&lang=css"

import exportComponent from "/builds/prv-dkomm/projects/edtools/zyklus3/ba-2021-trieu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__